<template>
  <!-- begin:: Aside -->
  <div class="aside aside-left d-flex aside-fixed" id="kt_aside" ref="kt_aside">
    <!--begin::Primary-->
    <div
      class="
                aside-primary
                d-flex
                flex-column
                align-items-center
                flex-row-auto
            "
    >
      <!--begin::Brand-->
      <KTBrand></KTBrand>
      <!--end::Brand-->
      <!--begin::Nav Wrapper-->
      <div
        class="
                    aside-nav
                    d-flex
                    flex-column
                    align-items-center
                    flex-column-fluid
                    py-5
                    scroll scroll-pull
                    ps
                "
        style="height: 420px; overflow: hidden"
      >
        <!--begin::Nav-->
        <ul class="nav flex-column" role="tablist">
          <!--begin::Item-->
          <li
            class="nav-item mb-3"
            data-placement="right"
            data-container="body"
            data-boundary="window"
            v-b-tooltip.hover.right="
              fgModoPR == 'R' ? 'Visualizar Pagar' : 'Visualizar Receber'
            "
          >
            <a
              href="javascript:;"
              class="
                                nav-link
                                btn btn-icon btn-clean btn-lg btn-menu-acessar
                            "
              :class="{
                receber: fgModoPR == 'P',
                pagar: fgModoPR == 'R'
              }"
              @click="setActiveTab(tabIndex)"
            >
              <span class="svg-icon svg-icon-xl">
                <!--begin::Svg Icon-->
                <inline-svg src="media/svg/icons/Layout/Layout-4-blocks.svg" />
                <!--end::Svg Icon-->
              </span>
            </a>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li
            class="nav-item mb-3"
            data-placement="right"
            data-container="body"
            data-boundary="window"
            v-b-tooltip.hover.right="'Acessar Filtros'"
            v-if="tabIndex == 1"
          >
            <a
              href="javascript:;"
              class="
                                nav-link
                                btn btn-icon btn-clean btn-lg btn-menu-acessar
                            "
              :class="{
                active: tabIndex == 0,
                receber: fgModoPR == 'R',
                pagar: fgModoPR == 'P'
              }"
              @click="setActiveTab(0, false)"
            >
              <span class="svg-icon svg-icon-xl">
                <!--begin::Svg Icon-->
                <inline-svg src="media/svg/icons/General/Search.svg" />
                <!--end::Svg Icon-->
              </span>
            </a>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li
            class="nav-item mb-3"
            data-placement="right"
            data-container="body"
            data-boundary="window"
            v-b-tooltip.hover.right="'Acessar Menus'"
            v-if="tabIndex == 0"
          >
            <a
              href="javascript:;"
              class="
                                nav-link 
                                btn btn-icon btn-clean btn-lg btn-menu-acessar
                            "
              :class="{
                active: tabIndex == 1,
                receber: fgModoPR == 'R',
                pagar: fgModoPR == 'P'
              }"
              @click="setActiveTab(1, false)"
            >
              <span class="svg-icon svg-icon-xl">
                <!--begin::Svg Icon-->
                <inline-svg src="media/svg/icons/Text/Align-justify.svg" />
                <!--end::Svg Icon-->
              </span>
            </a>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <!--<li class="nav-item mb-3" data-placement="right" data-container="body" data-boundary="window" v-b-tooltip.hover.right="'Latest Reports'">
                        <a href="#" class="nav-link btn btn-icon btn-clean btn-lg" :class="{active: (tabIndex == 2)}" v-on:click="setActiveTab(2)">
                            <span class="svg-icon svg-icon-xl">-->
          <!--begin::Svg Icon-->
          <!--<inline-svg src="media/svg/icons/Media/Equalizer.svg" />-->
          <!--end::Svg Icon-->
          <!--</span>
                        </a>
                    </li>-->
          <!--end::Item-->
          <!--begin::Item-->
          <!--<li class="nav-item mb-3" data-placement="right" data-container="body" data-boundary="window" v-b-tooltip.hover.right="'Project Management'">
                        <a href="#" class="nav-link btn btn-icon btn-clean btn-lg" :class="{active: (tabIndex == 3)}" v-on:click="setActiveTab(3)">
                            <span class="svg-icon svg-icon-xl">-->
          <!--begin::Svg Icon-->
          <!--<inline-svg src="media/svg/icons/General/Shield-check.svg" />-->
          <!--end::Svg Icon-->
          <!--</span>
                        </a>
                    </li>-->
          <!--end::Item-->
          <!--begin::Item-->
          <!--<li class="nav-item mb-3" data-placement="right" data-container="body" data-boundary="window" v-b-tooltip.hover.right="'User Management'">
                        <a href="#" class="nav-link btn btn-icon btn-clean btn-lg" :class="{active: (tabIndex == 4)}" v-on:click="setActiveTab(4)">
                            <span class="svg-icon svg-icon-xl">-->
          <!--begin::Svg Icon-->
          <!--<inline-svg src="media/svg/icons/Home/Library.svg" />-->
          <!--end::Svg Icon-->
          <!--</span>
                        </a>
                    </li>-->
          <!--end::Item-->
          <!--begin::Item-->
          <!--<li class="nav-item mb-3" data-placement="right" data-container="body" data-boundary="window" v-b-tooltip.hover.right="'Finance &amp; Accounting'">
                        <a href="#" class="nav-link btn btn-icon btn-clean btn-lg" :class="{active: (tabIndex == 5)}" v-on:click="setActiveTab(5)">
                            <span class="svg-icon svg-icon-xl">-->
          <!--begin::Svg Icon-->
          <!--<inline-svg src="media/svg/icons/Files/File-plus.svg" />-->
          <!--end::Svg Icon-->
          <!--</span>
                        </a>
                    </li>-->
          <!--end::Item-->
        </ul>
        <!--end::Nav-->
      </div>
      <!--end::Nav Wrapper-->
      <!--begin::Footer-->
      <div
        class="
                    aside-footer
                    d-flex
                    flex-column
                    align-items-center
                    flex-column-auto
                    py-4 py-lg-10
                "
      >
        <!--begin::Aside Toggle-->
        <span
          class="aside-toggle btn btn-icon btn-primary shadow-sm"
          :class="{
            receber: fgModoPR == 'R',
            pagar: fgModoPR == 'P'
          }"
          id="kt_aside_toggle"
          ref="kt_aside_toggle"
          data-placement="right"
          data-container="body"
          data-boundary="window"
          v-b-tooltip.hover.right="'Esconder/Mostrar'"
        >
          <i class="ki ki-bold-arrow-back icon-sm"></i>
        </span>
        <!--end::Aside Toggle-->

        <!--begin::Quick Actions-->
        <!--<KTQuickActions></KTQuickActions>-->
        <!--end::Quick Actions-->

        <!--begin::Quick Panel-->
        <!--<KTQuickPanel></KTQuickPanel>-->
        <!--end::Quick Panel-->

        <!--begin::User-->
        <KTQuickUser></KTQuickUser>
        <!--end::User-->
      </div>
      <!--end::Footer-->
    </div>
    <!--end::Primary-->
    <!--begin::Secondary-->
    <div class="aside-secondary d-flex flex-row-fluid">
      <!--begin::Workspace-->
      <div
        class="aside-workspace scroll scroll-push my-2 ps"
        style="height: 824px; overflow: hidden"
      >
        <!--begin::Tab Content-->
        <b-tabs class="hide-tabs" v-model="tabIndex">
          <!--begin::Tab Pane-->
          <b-tab active class="p-3 px-lg-7 py-lg-5">
            <!--begin::Form-->
            <form class="p-2 p-lg-3">
              <b-form-group>
                <b-form-select
                  v-model="empresa"
                  @change="buscarFluxos"
                  :options="empresas"
                  :disabled="fgLoading"
                ></b-form-select>
              </b-form-group>
              <div class="d-flex">
                <div class="input-icon h-40px" style="width: 100%">
                  <input
                    type="text"
                    class="
                                            form-control
                                            form-control-lg
                                            form-control-solid
                                            h-40px
                                        "
                    v-model="formProjetos.filtro"
                    placeholder="Buscar..."
                  />
                  <span>
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/General/Search.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                </div>
              </div>
            </form>
            <!--end::Form-->
            <h3 class="p-2 p-lg-3 my-1 my-lg-3">
              {{ filtroLateralDescricao }}
              <a
                href="javascript:;"
                class="btn btn-icon btn-primary shadow-sm"
                :class="{
                  receber: fgModoPR == 'R',
                  pagar: fgModoPR == 'P'
                }"
                data-placement="right"
                data-container="body"
                data-boundary="window"
                v-b-tooltip.hover.right="filtroLateralDescricaoProx"
                style="margin-left: 10px; height: 30px"
                @click="trocarFiltroLateral"
              >
                <i class="ki ki-bold-arrow-next icon-sm"></i>
              </a>
            </h3>
            <transition-group name="fade" enter-active-class="animated flip">
              <!--begin::List-->
              <div
                class="list list-hover"
                v-show="filtroLateral == 'PR'"
                key="PR"
              >
                <!--begin::Item-->
                <div
                  v-for="projetoItem in projetosFiltrados"
                  @click="selecionarProjeto(projetoItem.ID_PROJETO)"
                  :key="projetoItem.ID_PROJETO"
                  class="list-item hoverable p-2 p-lg-3 mb-2"
                  :class="{
                    active: fgProjeto == projetoItem.ID_PROJETO
                  }"
                >
                  <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="
                                                symbol symbol-40 symbol-light
                                                mr-4
                                            "
                    >
                      <span
                        class="
                                                    symbol-label
                                                    bg-hover-white
                                                "
                      >
                        <img
                          src="media/svg/misc/project-management.png"
                          class="
                                                        h-100
                                                        align-self-center
                                                    "
                        />
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Text-->
                    <div
                      class="
                                                d-flex
                                                flex-column flex-grow-1
                                                mr-2
                                            "
                    >
                      <span
                        class="
                                                    text-dark-75
                                                    font-size-h6
                                                    mb-0
                                                "
                      >
                        {{ projetoItem.DESCRICAO }}
                      </span>
                      <a
                        v-show="
                          (fgModoPR == 'R' && fgDashboardReceber) ||
                            (fgModoPR == 'P' && fgDashboardPagar)
                        "
                        href="javascript:;"
                        class="
                                                    text-muted
                                                    text-hover-primary
                                                    font-weight-bold
                                                "
                        :class="{
                          receber: fgModoPR == 'R',
                          pagar: fgModoPR == 'P'
                        }"
                      >
                        {{ calcProjetoReceber(projetoItem.ID_PROJETO) }}
                        <br />
                        {{ calcProjetoRecebido(projetoItem.ID_PROJETO) }}
                        pg
                      </a>
                    </div>
                    <!--begin::End-->
                  </div>
                </div>
                <!--end::Item-->
              </div>
              <!--end::List-->
              <!--begin::List-->
              <div
                class="list list-hover"
                v-show="filtroLateral == 'PF'"
                key="PF"
              >
                <!--begin::Item-->
                <div
                  v-for="planoFinanceiroItem in planosFinanceirosFiltrados"
                  @click="
                    selecionarPlanoFinanceiro(
                      planoFinanceiroItem.ID_PLANO_FINANCEIRO
                    )
                  "
                  :key="planoFinanceiroItem.ID_PLANO_FINANCEIRO"
                  class="list-item hoverable p-2 p-lg-3 mb-2"
                  :class="{
                    active:
                      fgPlanoFinanceiro ==
                      planoFinanceiroItem.ID_PLANO_FINANCEIRO
                  }"
                  v-show="
                    calcPlanoFinanceiroReceber(
                      planoFinanceiroItem.ID_PLANO_FINANCEIRO,
                      true
                    ) > 0
                  "
                >
                  <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="
                                                symbol symbol-40 symbol-light
                                                mr-4
                                            "
                    >
                      <span
                        class="
                                                    symbol-label
                                                    bg-hover-white
                                                "
                      >
                        <img
                          src="media/svg/misc/plano-financeiro.png"
                          class="
                                                        h-100
                                                        align-self-center
                                                    "
                        />
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Text-->
                    <div
                      class="
                                                d-flex
                                                flex-column flex-grow-1
                                                mr-2
                                            "
                    >
                      <span
                        class="
                                                    text-dark-75
                                                    font-size-h6
                                                    mb-0
                                                "
                      >
                        {{ planoFinanceiroItem.DESCRICAO }}
                      </span>
                      <a
                        v-show="
                          (fgModoPR == 'R' && fgDashboardReceber) ||
                            (fgModoPR == 'P' && fgDashboardPagar)
                        "
                        href="javascript:;"
                        class="
                                                    text-muted
                                                    text-hover-primary
                                                    font-weight-bold
                                                "
                        :class="{
                          receber: fgModoPR == 'R',
                          pagar: fgModoPR == 'P'
                        }"
                      >
                        {{
                          calcPlanoFinanceiroReceber(
                            planoFinanceiroItem.ID_PLANO_FINANCEIRO
                          )
                        }}
                        <br />
                        {{
                          calcPlanoFinanceiroRecebido(
                            planoFinanceiroItem.ID_PLANO_FINANCEIRO
                          )
                        }}
                        pg <br />
                        R$ 0,00 orç
                      </a>
                    </div>
                    <!--begin::End-->
                  </div>
                </div>
                <!--end::Item-->
                <!--begin::Item-->
                <div
                  v-if="temPlanosComValor() == false"
                  class="list-item hoverable p-2 p-lg-3 mb-2"
                >
                  <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="
                                                symbol symbol-40 symbol-light
                                                mr-4
                                            "
                    >
                      <span
                        class="
                                                    symbol-label
                                                    bg-hover-white
                                                "
                      >
                        <img
                          src="media/svg/misc/plano-financeiro.png"
                          class="
                                                        h-100
                                                        align-self-center
                                                    "
                        />
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Text-->
                    <div
                      class="
                                                d-flex
                                                flex-column flex-grow-1
                                                mr-2
                                            "
                    >
                      <span
                        class="
                                                    text-dark-75
                                                    font-size-h6
                                                    mb-0
                                                "
                      >
                        Sem Planos Financeiros Localizados no Filtro
                      </span>
                      <a
                        v-show="
                          (fgModoPR == 'R' && fgDashboardReceber) ||
                            (fgModoPR == 'P' && fgDashboardPagar)
                        "
                        href="javascript:;"
                        class="
                                                    text-muted
                                                    text-hover-primary
                                                    font-weight-bold
                                                "
                        :class="{
                          receber: fgModoPR == 'R',
                          pagar: fgModoPR == 'P'
                        }"
                      >
                        R$ 0,00
                      </a>
                    </div>
                    <!--begin::End-->
                  </div>
                </div>
                <!--end::Item-->
              </div>
              <!--end::List-->
              <!--begin::List-->
              <div
                class="list list-hover"
                v-show="filtroLateral == 'CR'"
                key="CR"
              >
                <!--begin::Item-->
                <div
                  v-for="centrosDeResponsabilidadeItem in centrosDeResponsabilidadeFiltrados"
                  @click="
                    selecionarCentroDeResponsabilidade(
                      centrosDeResponsabilidadeItem.ID_CENTRO_RESPONSABILIDADE
                    )
                  "
                  :key="
                    centrosDeResponsabilidadeItem.ID_CENTRO_RESPONSABILIDADE
                  "
                  class="list-item hoverable p-2 p-lg-3 mb-2"
                  :class="{
                    active:
                      fgCentroDeResponsabilidade ==
                      centrosDeResponsabilidadeItem.ID_CENTRO_RESPONSABILIDADE
                  }"
                  v-show="
                    calcCentrosDeResponsabilidadeReceber(
                      centrosDeResponsabilidadeItem.ID_CENTRO_RESPONSABILIDADE,
                      true
                    ) > 0
                  "
                >
                  <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="
                                                symbol symbol-40 symbol-light
                                                mr-4
                                            "
                    >
                      <span
                        class="
                                                    symbol-label
                                                    bg-hover-white
                                                "
                      >
                        <img
                          src="media/svg/misc/centro-responsabilidade.png"
                          class="
                                                        h-100
                                                        align-self-center
                                                    "
                        />
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Text-->
                    <div
                      class="
                                                d-flex
                                                flex-column flex-grow-1
                                                mr-2
                                            "
                    >
                      <span
                        class="
                                                    text-dark-75
                                                    font-size-h6
                                                    mb-0
                                                "
                      >
                        {{ centrosDeResponsabilidadeItem.DESCRICAO }}
                      </span>
                      <a
                        v-show="
                          (fgModoPR == 'R' && fgDashboardReceber) ||
                            (fgModoPR == 'P' && fgDashboardPagar)
                        "
                        href="javascript:;"
                        class="
                                                    text-muted
                                                    text-hover-primary
                                                    font-weight-bold
                                                "
                        :class="{
                          receber: fgModoPR == 'R',
                          pagar: fgModoPR == 'P'
                        }"
                      >
                        {{
                          calcCentrosDeResponsabilidadeReceber(
                            centrosDeResponsabilidadeItem.ID_CENTRO_RESPONSABILIDADE
                          )
                        }}
                        <br />
                        {{
                          calcCentrosDeResponsabilidadeRecebido(
                            centrosDeResponsabilidadeItem.ID_CENTRO_RESPONSABILIDADE
                          )
                        }}
                        pg <br />
                        R$ 0,00 orç
                      </a>
                    </div>
                    <!--begin::End-->
                  </div>
                </div>
                <!--end::Item-->
                <!--begin::Item-->
                <div
                  v-if="temCentrosComValor() == false"
                  class="list-item hoverable p-2 p-lg-3 mb-2"
                >
                  <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="
                                                symbol symbol-40 symbol-light
                                                mr-4
                                            "
                    >
                      <span
                        class="
                                                    symbol-label
                                                    bg-hover-white
                                                "
                      >
                        <img
                          src="media/svg/misc/centro-responsabilidade.png"
                          class="
                                                        h-100
                                                        align-self-center
                                                    "
                        />
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Text-->
                    <div
                      class="
                                                d-flex
                                                flex-column flex-grow-1
                                                mr-2
                                            "
                    >
                      <span
                        class="
                                                    text-dark-75
                                                    font-size-h6
                                                    mb-0
                                                "
                      >
                        Sem Centros de Responsabilidade Localizados no Filtro
                      </span>
                      <a
                        v-show="
                          (fgModoPR == 'R' && fgDashboardReceber) ||
                            (fgModoPR == 'P' && fgDashboardPagar)
                        "
                        href="javascript:;"
                        class="
                                                    text-muted
                                                    text-hover-primary
                                                    font-weight-bold
                                                "
                        :class="{
                          receber: fgModoPR == 'R',
                          pagar: fgModoPR == 'P'
                        }"
                      >
                        R$ 0,00
                      </a>
                    </div>
                    <!--begin::End-->
                  </div>
                </div>
                <!--end::Item-->
              </div>
              <!--end::List-->
              <!--begin::List-->
              <div
                class="list list-hover"
                v-show="filtroLateral == 'PT'"
                key="PT"
              >
                <!--begin::Item-->
                <div
                  v-for="portadorItem in portadoresFiltrados"
                  @click="selecionarPortador(portadorItem.ID_PORTADOR)"
                  :key="portadorItem.ID_PORTADOR"
                  class="list-item hoverable p-2 p-lg-3 mb-2"
                  :class="{
                    active: fgPortador == portadorItem.ID_PORTADOR
                  }"
                >
                  <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="
                                                symbol symbol-40 symbol-light
                                                mr-4
                                            "
                    >
                      <span
                        class="
                                                    symbol-label
                                                    bg-hover-white
                                                "
                      >
                        <img
                          src="media/svg/misc/portador.png"
                          class="
                                                        h-100
                                                        align-self-center
                                                    "
                        />
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Text-->
                    <div
                      class="
                                                d-flex
                                                flex-column flex-grow-1
                                                mr-2
                                            "
                    >
                      <span
                        class="
                                                    text-dark-75
                                                    font-size-h6
                                                    mb-0
                                                "
                      >
                        {{ portadorItem.NOME }}
                      </span>
                      <a
                        v-show="
                          (fgModoPR == 'R' && fgDashboardReceber) ||
                            (fgModoPR == 'P' && fgDashboardPagar)
                        "
                        href="javascript:;"
                        class="
                                                    text-muted
                                                    text-hover-primary
                                                    font-weight-bold
                                                "
                        :class="{
                          receber: fgModoPR == 'R',
                          pagar: fgModoPR == 'P'
                        }"
                      >
                        {{ calcPortadorReceber(portadorItem.ID_PORTADOR) }}
                        <br />
                        {{ calcPortadorRecebido(portadorItem.ID_PORTADOR) }}
                        pg <br />
                        {{ valorFormatado(portadorItem.SALDO_BANCO) }}
                        saldo
                      </a>
                    </div>
                    <!--begin::End-->
                  </div>
                </div>
                <!--end::Item-->
              </div>
              <!--end::List-->
            </transition-group>
          </b-tab>
          <!--end::Tab Pane-->
          <!--begin::Tab Pane-->
          <b-tab>
            <!--begin::Aside Menu-->
            <div
              class="
                                aside-menu-wrapper
                                flex-column-fluid
                                px-10
                                py-5
                            "
              id="kt_aside_menu_wrapper"
            >
              <!--begin::Menu Container-->
              <div
                ref="kt_aside_menu"
                id="kt_aside_menu"
                class="aside-menu min-h-lg-800px"
                data-menu-vertical="1"
                data-menu-scroll="1"
                v-bind:class="asideMenuClass"
              >
                <!-- example static menu here -->
                <perfect-scrollbar
                  class="aside-menu scroll"
                  style="max-height: 90vh; position: relative"
                >
                  <KTMenu></KTMenu>
                </perfect-scrollbar>
              </div>
              <!--end::Menu Container-->
            </div>
            <!--end::Aside Menu-->
          </b-tab>
          <!--end::Tab Pane-->
          <!--begin::Tab Pane-->
          <b-tab active class="p-3 px-lg-7 py-lg-5">
            <!--begin::Form-->
            <form class="p-2 p-lg-3">
              <div class="d-flex">
                <div class="input-icon h-40px">
                  <input
                    type="text"
                    class="
                                            form-control
                                            form-control-lg
                                            form-control-solid
                                            h-40px
                                        "
                    placeholder="Buscar..."
                  />
                  <span>
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/General/Search.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                </div>
                <div class="dropdown" v-b-tooltip.hover.right="'Quick actions'">
                  <a
                    href="#"
                    class="
                                            btn
                                            btn-icon
                                            btn-default
                                            btn-hover-primary
                                            ml-2
                                            h-40px
                                            w-40px
                                            flex-shrink-0
                                        "
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/Code/Compiling.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </a>
                  <div
                    class="
                                            dropdown-menu
                                            dropdown-menu-md
                                            dropdown-menu-right
                                        "
                    style=""
                  >
                    <!--begin::Navigation-->
                    <ul class="navi navi-hover py-5">
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-drop
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">New Group</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-list-3
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Contacts</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-rocket-1
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Groups</span>
                          <span class="navi-link-badge">
                            <span
                              class="
                                                                label
                                                                label-light-primary
                                                                label-inline
                                                                font-weight-bold
                                                            "
                            >
                              new
                            </span>
                          </span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-bell-2
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Calls</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-gear
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Settings</span>
                        </a>
                      </li>
                      <li class="navi-separator my-3"></li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-magnifier-tool
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Help</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-bell-2
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Privacy</span>
                          <span class="navi-link-badge">
                            <span
                              class="
                                                                label
                                                                label-light-danger
                                                                label-rounded
                                                                font-weight-bold
                                                            "
                              >5</span
                            >
                          </span>
                        </a>
                      </li>
                    </ul>
                    <!--end::Navigation-->
                  </div>
                </div>
              </div>
            </form>
            <!--end::Form-->
            <h3 class="p-2 p-lg-3 my-1 my-lg-3">Projetos</h3>
            <!--begin::List-->
            <div class="list list-hover">
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/006-plurk.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Anuidade 2020
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      R$840.397,35
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/010-vimeo.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Anuidade 2021
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      R$5.814,00
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/014-kickstarter.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Congresso 2020
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      ---
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/009-hot-air-balloon.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Congresso 2021
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      ---
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
            </div>
            <!--end::List-->
          </b-tab>
          <!--end::Tab Pane-->
          <!--begin::Tab Pane-->
          <b-tab active class="p-3 px-lg-7 py-lg-5">
            <!--begin::Form-->
            <form class="p-2 p-lg-3">
              <div class="d-flex">
                <div class="input-icon h-40px">
                  <input
                    type="text"
                    class="
                                            form-control
                                            form-control-lg
                                            form-control-solid
                                            h-40px
                                        "
                    placeholder="Buscar..."
                  />
                  <span>
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/General/Search.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                </div>
                <div class="dropdown" v-b-tooltip.hover.right="'Quick actions'">
                  <a
                    href="#"
                    class="
                                            btn
                                            btn-icon
                                            btn-default
                                            btn-hover-primary
                                            ml-2
                                            h-40px
                                            w-40px
                                            flex-shrink-0
                                        "
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/Code/Compiling.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </a>
                  <div
                    class="
                                            dropdown-menu
                                            dropdown-menu-md
                                            dropdown-menu-right
                                        "
                    style=""
                  >
                    <!--begin::Navigation-->
                    <ul class="navi navi-hover py-5">
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-drop
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">New Group</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-list-3
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Contacts</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-rocket-1
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Groups</span>
                          <span class="navi-link-badge">
                            <span
                              class="
                                                                label
                                                                label-light-primary
                                                                label-inline
                                                                font-weight-bold
                                                            "
                            >
                              new
                            </span>
                          </span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-bell-2
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Calls</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-gear
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Settings</span>
                        </a>
                      </li>
                      <li class="navi-separator my-3"></li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-magnifier-tool
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Help</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-bell-2
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Privacy</span>
                          <span class="navi-link-badge">
                            <span
                              class="
                                                                label
                                                                label-light-danger
                                                                label-rounded
                                                                font-weight-bold
                                                            "
                              >5</span
                            >
                          </span>
                        </a>
                      </li>
                    </ul>
                    <!--end::Navigation-->
                  </div>
                </div>
              </div>
            </form>
            <!--end::Form-->
            <h3 class="p-2 p-lg-3 my-1 my-lg-3">Projetos</h3>
            <!--begin::List-->
            <div class="list list-hover">
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/006-plurk.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Anuidade 2020
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      R$840.397,35
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/010-vimeo.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Anuidade 2021
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      R$5.814,00
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/014-kickstarter.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Congresso 2020
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      ---
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/009-hot-air-balloon.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Congresso 2021
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      ---
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
            </div>
            <!--end::List-->
          </b-tab>
          <!--end::Tab Pane-->
          <!--begin::Tab Pane-->
          <b-tab active class="p-3 px-lg-7 py-lg-5">
            <!--begin::Form-->
            <form class="p-2 p-lg-3">
              <div class="d-flex">
                <div class="input-icon h-40px">
                  <input
                    type="text"
                    class="
                                            form-control
                                            form-control-lg
                                            form-control-solid
                                            h-40px
                                        "
                    placeholder="Buscar..."
                  />
                  <span>
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/General/Search.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                </div>
                <div class="dropdown" v-b-tooltip.hover.right="'Quick actions'">
                  <a
                    href="#"
                    class="
                                            btn
                                            btn-icon
                                            btn-default
                                            btn-hover-primary
                                            ml-2
                                            h-40px
                                            w-40px
                                            flex-shrink-0
                                        "
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/Code/Compiling.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </a>
                  <div
                    class="
                                            dropdown-menu
                                            dropdown-menu-md
                                            dropdown-menu-right
                                        "
                    style=""
                  >
                    <!--begin::Navigation-->
                    <ul class="navi navi-hover py-5">
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-drop
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">New Group</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-list-3
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Contacts</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-rocket-1
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Groups</span>
                          <span class="navi-link-badge">
                            <span
                              class="
                                                                label
                                                                label-light-primary
                                                                label-inline
                                                                font-weight-bold
                                                            "
                            >
                              new
                            </span>
                          </span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-bell-2
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Calls</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-gear
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Settings</span>
                        </a>
                      </li>
                      <li class="navi-separator my-3"></li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-magnifier-tool
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Help</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-bell-2
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Privacy</span>
                          <span class="navi-link-badge">
                            <span
                              class="
                                                                label
                                                                label-light-danger
                                                                label-rounded
                                                                font-weight-bold
                                                            "
                              >5</span
                            >
                          </span>
                        </a>
                      </li>
                    </ul>
                    <!--end::Navigation-->
                  </div>
                </div>
              </div>
            </form>
            <!--end::Form-->
            <h3 class="p-2 p-lg-3 my-1 my-lg-3">Projetos</h3>
            <!--begin::List-->
            <div class="list list-hover">
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/006-plurk.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Anuidade 2020
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      R$840.397,35
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/010-vimeo.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Anuidade 2021
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      R$5.814,00
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/014-kickstarter.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Congresso 2020
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      ---
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/009-hot-air-balloon.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Congresso 2021
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      ---
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
            </div>
            <!--end::List-->
          </b-tab>
          <!--end::Tab Pane-->
          <!--begin::Tab Pane-->
          <b-tab active class="p-3 px-lg-7 py-lg-5">
            <!--begin::Form-->
            <form class="p-2 p-lg-3">
              <div class="d-flex">
                <div class="input-icon h-40px">
                  <input
                    type="text"
                    class="
                                            form-control
                                            form-control-lg
                                            form-control-solid
                                            h-40px
                                        "
                    placeholder="Buscar..."
                  />
                  <span>
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/General/Search.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                </div>
                <div class="dropdown" v-b-tooltip.hover.right="'Quick actions'">
                  <a
                    href="#"
                    class="
                                            btn
                                            btn-icon
                                            btn-default
                                            btn-hover-primary
                                            ml-2
                                            h-40px
                                            w-40px
                                            flex-shrink-0
                                        "
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="svg-icon svg-icon-lg">
                      <!--begin::Svg Icon-->
                      <inline-svg src="media/svg/icons/Code/Compiling.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </a>
                  <div
                    class="
                                            dropdown-menu
                                            dropdown-menu-md
                                            dropdown-menu-right
                                        "
                    style=""
                  >
                    <!--begin::Navigation-->
                    <ul class="navi navi-hover py-5">
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-drop
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">New Group</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-list-3
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Contacts</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-rocket-1
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Groups</span>
                          <span class="navi-link-badge">
                            <span
                              class="
                                                                label
                                                                label-light-primary
                                                                label-inline
                                                                font-weight-bold
                                                            "
                            >
                              new
                            </span>
                          </span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-bell-2
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Calls</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-gear
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Settings</span>
                        </a>
                      </li>
                      <li class="navi-separator my-3"></li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-magnifier-tool
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Help</span>
                        </a>
                      </li>
                      <li class="navi-item">
                        <a href="#" class="navi-link">
                          <span class="navi-icon">
                            <i
                              class="
                                                                flaticon2-bell-2
                                                            "
                            ></i>
                          </span>
                          <span class="navi-text">Privacy</span>
                          <span class="navi-link-badge">
                            <span
                              class="
                                                                label
                                                                label-light-danger
                                                                label-rounded
                                                                font-weight-bold
                                                            "
                              >5</span
                            >
                          </span>
                        </a>
                      </li>
                    </ul>
                    <!--end::Navigation-->
                  </div>
                </div>
              </div>
            </form>
            <!--end::Form-->
            <h3 class="p-2 p-lg-3 my-1 my-lg-3">Projetos</h3>
            <!--begin::List-->
            <div class="list list-hover">
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/006-plurk.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Anuidade 2020
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      R$840.397,35
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/010-vimeo.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Anuidade 2021
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      R$5.814,00
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/014-kickstarter.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Congresso 2020
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      ---
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
              <!--begin::Item-->
              <div class="list-item hoverable p-2 p-lg-3 mb-2">
                <div class="d-flex align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="
                                            symbol symbol-40 symbol-light
                                            mr-4
                                        "
                  >
                    <span class="symbol-label bg-hover-white">
                      <inline-svg
                        src="media/svg/misc/009-hot-air-balloon.svg"
                        class="h-50 align-self-center"
                      />
                    </span>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Text-->
                  <div
                    class="
                                            d-flex
                                            flex-column flex-grow-1
                                            mr-2
                                        "
                  >
                    <span
                      class="
                                                text-dark-75
                                                font-size-h6
                                                mb-0
                                            "
                    >
                      Congresso 2021
                    </span>
                    <a
                      href="#"
                      class="
                                                text-muted text-hover-primary
                                                font-weight-bold
                                            "
                    >
                      ---
                    </a>
                  </div>
                  <!--begin::End-->
                </div>
              </div>
              <!--end::Item-->
            </div>
            <!--end::List-->
          </b-tab>
          <!--end::Tab Pane-->
        </b-tabs>
        <!--end::Tab Content-->
        <!--end::Workspace-->
      </div>
      <!--end::Secondary-->
    </div>
  </div>
  <!-- end:: Aside -->
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}

.btn-menu-acessar.receber .svg-icon svg g [fill] {
  fill: #1bc5bd !important;
}

.btn-menu-acessar.pagar .svg-icon svg g [fill] {
  fill: #f64e60 !important;
}

.hoverable:hover .text-hover-primary.receber:hover {
  color: #1bc5bd !important;
}

.hoverable:hover .text-hover-primary.receber {
  color: #1bc5bd !important;
}

.text-hover-primary.receber:hover {
  color: #1bc5bd !important;
}

.hoverable:hover .text-hover-primary.pagar:hover {
  color: #f64e60 !important;
}

.hoverable:hover .text-hover-primary.pagar {
  color: #f64e60 !important;
}

.text-hover-primary.pagar:hover {
  color: #f64e60 !important;
}

.btn.btn-primary.receber {
  background-color: #1bc5bd !important;
  border-color: #1bc5bd !important;
}

.btn.btn-primary.receber:hover {
  background-color: #1bc5bd !important;
  border-color: #1bc5bd !important;
}

.btn.btn-primary.pagar {
  background-color: #f64e60 !important;
  border-color: #f64e60 !important;
}

.btn.btn-primary.pagar:hover {
  background-color: #f64e60 !important;
  border-color: #f64e60 !important;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

import KTLayoutAside from "@/assets/js/layout/base/aside.js";
import KTLayoutAsideMenu from "@/assets/js/layout/base/aside-menu.js";
import KTLayoutAsideToggle from "@/assets/js/layout/base/aside-toggle.js";
import KTBrand from "@/view/layout/brand/Brand.vue";
import KTMenu from "@/view/layout/aside/Menu.vue";
//import KTQuickActions from "@/view/layout/extras/offcanvas/QuickActions.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
//import KTQuickPanel from "@/view/layout/extras/offcanvas/QuickPanel.vue";

import Swal from "sweetalert2";

export default {
  name: "KTAside",
  data() {
    return {
      insideTm: 0,
      outsideTm: 0,
      tabIndex: 0,
      formProjetos: {
        filtro: ""
      },
      filtroLateral: "PR",
      filtroLateralDescricao: "Projetos",
      filtroLateralDescricaoProx: "Planos Financeiros"
    };
  },
  components: {
    KTBrand,
    KTMenu,
    //KTQuickActions,
    KTQuickUser
    //KTQuickPanel
  },
  async mounted() {
    let vm = this;

    this.$nextTick(() => {
      // Init Aside
      KTLayoutAside.init(this.$refs["kt_aside"]);

      // Init Aside Menu
      KTLayoutAsideMenu.init(this.$refs["kt_aside_menu"]);

      // Init Aside Toggle
      KTLayoutAsideToggle.init(this.$refs["kt_aside_toggle"]);

      window.dispatchEvent(new Event("resize"));

      if (vm.verificado) {
        vm.buscarPermissoes();
      } else {
        window.addEventListener(
          "autorizado",
          function() {
            vm.buscarPermissoes();
          },
          false
        );
      }

      this.setActiveTab(0, false);
    });
  },
  methods: {
    ...mapActions([
      "getPermissoes",
      "getProjetos",
      "getPlanosFinanceiros",
      "getCentrosDeResponsabilidade",
      "getPortadores",
      "getEmpresas",
      "getFluxosDeCaixa",
      "getEmitentePrincipal",
      "updateFgEmpresa",
      "updateFgProjeto",
      "updateFgLoading",
      "updateFgModoPR",
      "updateFgPlanoFinanceiro",
      "updateFgCentroDeResponsabilidade",
      "updateFgPortador",
      "getAutorizacaoPermissao",
      "updateFgMaster",
      "updateFgSecurity",
      "updateFgConfiguracoes",
      "updateFgDashboardPagar",
      "updateFgDashboardReceber"
    ]),
    async setActiveTab(indice, mudaModo = true) {
      /*let target = event.target;

                if (!event.target.classList.contains("nav-link")) {
                    target = event.target.closest(".nav-link");
                }

                const tab = target.closest('[role="tablist"]');
                const links = tab.querySelectorAll(".nav-link");

                // remove active tab links
                for (let i = 0; i < links.length; i++) {
                    links[i].classList.remove("active");
                }

                // set clicked tab index to bootstrap tab
                this.tabIndex = parseInt(target.getAttribute("data-tab"));

                // set current active tab
                target.classList.add("active");*/

      this.tabIndex = indice;

      if (mudaModo) {
        if (!this.fgLoading6meses && !this.fgLoading) {
          let permReceber = await this.getAutorizacaoPermissao(
            "PAYLOGOS_RECEBER"
          );
          let permPagar = await this.getAutorizacaoPermissao("PAYLOGOS_PAGAR");

          if (this.fgModoPR == "R") {
            if (permPagar) {
              this.updateFgModoPR("P");
            } else {
              Swal.fire({
                title: "",
                text: "Você não tem permissão para visualizar o pagar.",
                icon: "warning",
                timer: 3000,
                showConfirmButton: false
              });
            }
          } else {
            if (permReceber) {
              this.updateFgModoPR("R");
            } else {
              Swal.fire({
                title: "",
                text: "Você não tem permissão para visualizar o receber.",
                icon: "warning",
                timer: 3000,
                showConfirmButton: false
              });
            }
          }

          this.$root.$emit("trocaTipoPR", {});
          this.$router.push({ path: "/dashboard" });

        } else {
          Swal.fire({
            title: "",
            text: "Carregando informações, por favor aguarde.",
            icon: "warning",
            timer: 3000,
            showConfirmButton: false
          });
        }
      }
    },
    filtrarNome() {
      if (this.formProjetos.filtro) {
        let projetosFiltrados = [];

        this.projetos.forEach(function(itemProjeto) {
          if (itemProjeto.DESCRICAO.indexOf(this.formProjetos.filtro) >= 0) {
            projetosFiltrados.push(itemProjeto);
          }
        });

        return projetosFiltrados;
      } else {
        return this.projetos;
      }
    },
    calcProjetoReceber(idProjeto) {
      var valor = 0;

      this.fluxosDeCaixaValoresTotaisProjetos.forEach(function(projeto) {
        if (projeto.ID_PROJETO == idProjeto) {
          valor = projeto.VALOR;
        }
      });

      return valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
      });
    },
    calcProjetoRecebido(idProjeto) {
      var valor = 0;

      this.fluxosDeCaixaValoresTotaisProjetos.forEach(function(projeto) {
        if (projeto.ID_PROJETO == idProjeto && projeto.VALOR_PAGO) {
          valor = projeto.VALOR_PAGO;
        }
      });

      return valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
      });
    },
    calcPlanoFinanceiroReceber(idPlanoFinanceiro, bIntVal = false) {
      var valor = 0;

      this.fluxosDeCaixaValoresTotaisPlanosFinanceiros.forEach(function(
        planoFinanceiro
      ) {
        if (planoFinanceiro.ID_PLANO_FINANCEIRO == idPlanoFinanceiro) {
          valor = planoFinanceiro.VALOR;
        }
      });

      if (bIntVal) {
        return valor;
      } else {
        return valor.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL"
        });
      }
    },
    calcPlanoFinanceiroRecebido(idPlanoFinanceiro) {
      var valor = 0;

      this.fluxosDeCaixaValoresTotaisPlanosFinanceiros.forEach(function(
        planoFinanceiro
      ) {
        if (
          planoFinanceiro.ID_PLANO_FINANCEIRO == idPlanoFinanceiro &&
          planoFinanceiro.VALOR_PAGO
        ) {
          valor = planoFinanceiro.VALOR_PAGO;
        }
      });

      return valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
      });
    },
    calcCentrosDeResponsabilidadeReceber(
      idCentroDeResponsabilidade,
      bIntVal = false
    ) {
      var valor = 0;

      this.fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade.forEach(function(
        centroDeResponsabilidade
      ) {
        if (
          centroDeResponsabilidade.ID_CENTRO_RESPONSABILIDADE ==
          idCentroDeResponsabilidade
        ) {
          valor = centroDeResponsabilidade.VALOR;
        }
      });

      if (bIntVal) {
        return valor;
      } else {
        return valor.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL"
        });
      }
    },
    calcCentrosDeResponsabilidadeRecebido(idCentroDeResponsabilidade) {
      var valor = 0;

      this.fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade.forEach(function(
        centroDeResponsabilidade
      ) {
        if (
          centroDeResponsabilidade.ID_CENTRO_RESPONSABILIDADE ==
            idCentroDeResponsabilidade &&
          centroDeResponsabilidade.VALOR_PAGO
        ) {
          valor = centroDeResponsabilidade.VALOR_PAGO;
        }
      });

      return valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL"
      });
    },
    calcPortadorReceber(idPortador, bIntVal = false) {
      var valor = 0;

      this.fluxosDeCaixaValoresTotaisPortadores.forEach(function(portador) {
        if (portador.ID_PORTADOR == idPortador) {
          valor = portador.VALOR;
        }
      });

      if (bIntVal) {
        return valor;
      } else {
        return this.valorFormatado(valor);
      }
    },
    calcPortadorRecebido(idPortador) {
      var valor = 0;

      this.fluxosDeCaixaValoresTotaisPortadores.forEach(function(portador) {
        if (portador.ID_PORTADOR == idPortador && portador.VALOR_PAGO) {
          valor = portador.VALOR_PAGO;
        }
      });

      return this.valorFormatado(valor);
    },
    valorFormatado(valor) {
      if (valor) {
        return valor.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL"
        });
      } else {
        return "R$ 0,00";
      }
    },
    async buscarFluxos(busca6meses = true) {
      this.updateFgLoading(true);

      await this.getFluxosDeCaixa({
        inicio: this.fgDataInicio,
        fim: this.fgDataFim,
        empresa: this.fgEmpresa,
        projeto: this.fgProjeto,
        planoFinanceiro: this.fgPlanoFinanceiro,
        centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
        portador: this.fgPortador,
        tipo: this.fgModoPR,
        fluxoDeCaixaBusca: this.fluxoDeCaixaBusca,
        filtroAbas: this.fgFiltroAbas,
        dataFiltroTipo: this.fgDataFiltroTipo,
        emitente: this.fgEmitente,
        ordenacaoFiltroTipo: this.fgOrdenacaoFiltroTipo
      });

      this.updateFgLoading(false);

      if (busca6meses) {
        this.$root.$emit("buscarGrafico6MesesWidget", {});
      }
    },
    selecionarProjeto(idProjeto) {
      if (!this.fgLoading) {
        if (idProjeto == this.fgProjeto) {
          this.updateFgProjeto("0");
        } else {
          this.updateFgProjeto(idProjeto);
        }

        this.buscarFluxos();
      }
    },
    selecionarPlanoFinanceiro(idPlanoFinanceiro) {
      if (!this.fgLoading) {
        if (idPlanoFinanceiro == this.fgPlanoFinanceiro) {
          this.updateFgPlanoFinanceiro("0");
        } else {
          this.updateFgPlanoFinanceiro(idPlanoFinanceiro);
        }

        this.buscarFluxos();
      }
    },
    selecionarCentroDeResponsabilidade(idCentroDeResponsabilidade) {
      if (!this.fgLoading) {
        if (idCentroDeResponsabilidade == this.fgCentroDeResponsabilidade) {
          this.updateFgCentroDeResponsabilidade("0");
        } else {
          this.updateFgCentroDeResponsabilidade(idCentroDeResponsabilidade);
        }

        this.buscarFluxos();
      }
    },
    selecionarPortador(idPortador) {
      if (!this.fgLoading) {
        if (idPortador == this.fgPortador) {
          this.updateFgPortador("0");
        } else {
          this.updateFgPortador(idPortador);
        }

        this.buscarFluxos();
      }
    },
    trocarFiltroLateral() {
      if (this.filtroLateral == "PR") {
        this.filtroLateral = "PF";
        this.filtroLateralDescricao = "Planos Financeiros";
        this.filtroLateralDescricaoProx = "Centros de Responsabilidade";
      } else if (this.filtroLateral == "PF") {
        this.filtroLateral = "CR";
        this.filtroLateralDescricao = "Centros de Responsabilidade";
        this.filtroLateralDescricaoProx = "Portadores";
      } else if (this.filtroLateral == "CR") {
        this.filtroLateral = "PT";
        this.filtroLateralDescricao = "Portadores";
        this.filtroLateralDescricaoProx = "Projetos";
      } else if (this.filtroLateral == "PT") {
        this.filtroLateral = "PR";
        this.filtroLateralDescricao = "Projetos";
        this.filtroLateralDescricaoProx = "Planos Financeiros";
      }
    },
    async buscarPermissoes() {
      await this.getPermissoes();

      let bPermitido = false;

      let permReceber = await this.getAutorizacaoPermissao("PAYLOGOS_RECEBER");

      let permissaoMaster = await this.getAutorizacaoPermissao("MASTER");
      let permissaoSecurity = await this.getAutorizacaoPermissao("SECURITY");
      let permissaoConfiguracoes = await this.getAutorizacaoPermissao(
        "PAYLOGOS_CONFIGURACOES"
      );
      let permissaoDashboardReceber = await this.getAutorizacaoPermissao(
        "PAYLOGOS_RECEBER_DASHBOARD"
      );
      let permissaoDashboardPagar = await this.getAutorizacaoPermissao(
        "PAYLOGOS_PAGAR_DASHBOARD"
      );

      this.updateFgMaster(permissaoMaster);
      this.updateFgSecurity(permissaoSecurity);
      this.updateFgConfiguracoes(permissaoConfiguracoes);
      this.updateFgDashboardReceber(permissaoDashboardReceber);
      this.updateFgDashboardPagar(permissaoDashboardPagar);

      if (!permReceber) {
        let permPagar = await this.getAutorizacaoPermissao("PAYLOGOS_PAGAR");

        if (permPagar) {
          this.updateFgModoPR("P");
          bPermitido = true;
        }
      } else {
        bPermitido = true;
      }

      if (bPermitido) {
        await this.getEmitentePrincipal();
        await this.getProjetos();
        await this.getPlanosFinanceiros();
        await this.getCentrosDeResponsabilidade();
        await this.getPortadores();
        await this.getEmpresas();

        this.updateFgLoading(true);

        await this.getFluxosDeCaixa({
          inicio: this.fgDataInicio,
          fim: this.fgDataFim,
          empresa: this.fgEmpresa,
          projeto: this.fgProjeto,
          planoFinanceiro: this.fgPlanoFinanceiro,
          centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
          portador: this.fgPortador,
          tipo: this.fgModoPR,
          fluxoDeCaixaBusca: this.fluxoDeCaixaBusca,
          filtroAbas: this.fgFiltroAbas,
          dataFiltroTipo: this.fgDataFiltroTipo,
          emitente: this.fgEmitente,
        ordenacaoFiltroTipo: this.fgOrdenacaoFiltroTipo
        });

        this.updateFgLoading(false);
      } else {
        Swal.fire({
          title: "",
          text:
            "Você não tem permissão para visualizar o módulo de PAGAR nem o módulo de RECEBER.",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });
      }
    },
    temPlanosComValor() {
      let bAchei = false;
      let vm = this;

      this.planosFinanceirosFiltrados.forEach(function(planoFinanceiro) {
        if (
          vm.calcPlanoFinanceiroReceber(
            planoFinanceiro.ID_PLANO_FINANCEIRO,
            true
          ) > 0
        ) {
          bAchei = true;
        }
      });

      return bAchei;
    },
    temCentrosComValor() {
      let bAchei = false;
      let vm = this;

      this.centrosDeResponsabilidadeFiltrados.forEach(function(
        centroDeResponsabilidade
      ) {
        if (
          vm.calcCentrosDeResponsabilidadeReceber(
            centroDeResponsabilidade.ID_CENTRO_RESPONSABILIDADE,
            true
          ) > 0
        ) {
          bAchei = true;
        }
      });

      return bAchei;
    }
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "getClasses",
      "projetos",
      "planosFinanceiros",
      "centrosDeResponsabilidade",
      "portadores",
      "empresas",
      "fluxosDeCaixa",
      "verificado",
      "fgDataInicio",
      "fgDataFim",
      "fgEmpresa",
      "fgProjeto",
      "fgPlanoFinanceiro",
      "fgCentroDeResponsabilidade",
      "fgPortador",
      "fgLoading",
      "fgModoPR",
      "fgLoading6meses",
      "fgDashboardPagar",
      "fgDashboardReceber",
      "fluxoDeCaixaBusca",
      "fgFiltroAbas",
      "fgDataFiltroTipo",
      "fluxosDeCaixaValoresTotaisProjetos",
      "fluxosDeCaixaValoresTotaisPlanosFinanceiros",
      "fluxosDeCaixaValoresTotaisCentrosDeResponsabilidade",
      "fluxosDeCaixaValoresTotaisPortadores",
      "fgEmitente",
      "fgOrdenacaoFiltroTipo"
    ]),
    empresa: {
      get() {
        return this.fgEmpresa;
      },
      set(value) {
        this.updateFgEmpresa(value);
      }
    },
    asideMenuClass() {
      const classes = this.getClasses("aside_menu");

      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }

      return null;
    },
    projetosFiltrados() {
      let vm = this;

      if (this.projetos) {
        if (this.projetos.length) {
          return this.projetos.filter(function(projetoItem) {
            let dentroDataInicio = false;
            let dentroDataFim = false;

            if (projetoItem.DATA_INICIO) {
              let dtInicio = moment(
                projetoItem.DATA_INICIO,
                "YYYYMMDD[T]HHmmss"
              ).format("YYYY-MM-DD");
              let hoje = moment().format("YYYY-MM-DD");

              if (dtInicio <= hoje) {
                dentroDataInicio = true;
              }
            } else {
              dentroDataInicio = false;
            }

            if (dentroDataInicio) {
              if (projetoItem.DATA_FIM) {
                let dtFim = moment(
                  projetoItem.DATA_FIM,
                  "YYYYMMDD[T]HHmmss"
                ).format("YYYY-MM-DD");
                let hoje = moment().format("YYYY-MM-DD");

                if (dtFim >= hoje) {
                  dentroDataFim = true;
                }
              } else {
                dentroDataFim = true;
              }

              if (dentroDataFim) {
                if (vm.fgEmpresa !== "0") {
                  if (
                    projetoItem.ID_EMPRESA &&
                    projetoItem.ID_EMPRESA !== "0"
                  ) {
                    if (vm.fgEmpresa == projetoItem.ID_EMPRESA) {
                      if (vm.formProjetos.filtro) {
                        if (
                          projetoItem.DESCRICAO.indexOf(
                            vm.formProjetos.filtro
                          ) >= 0
                        ) {
                          return true;
                        } else {
                          return false;
                        }
                      } else {
                        return true;
                      }
                    } else {
                      return false;
                    }
                  } else {
                    if (vm.formProjetos.filtro) {
                      if (
                        projetoItem.DESCRICAO.indexOf(vm.formProjetos.filtro) >=
                        0
                      ) {
                        return true;
                      } else {
                        return false;
                      }
                    } else {
                      return true;
                    }
                  }
                } else {
                  if (vm.formProjetos.filtro) {
                    if (
                      projetoItem.DESCRICAO.indexOf(vm.formProjetos.filtro) >= 0
                    ) {
                      return true;
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                }
              } else {
                return false;
              }
            } else {
              return false;
            }
          });
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    planosFinanceirosFiltrados() {
      let vm = this;

      if (this.planosFinanceiros) {
        if (this.planosFinanceiros.length) {
          return this.planosFinanceiros.filter(function(planoFinanceiroItem) {
            let dentroDoFiltro = false;

            if (
              (planoFinanceiroItem.DEBITO_CREDITO == "C" &&
                vm.fgModoPR == "R") ||
              (planoFinanceiroItem.DEBITO_CREDITO == "D" && vm.fgModoPR == "P")
            ) {
              dentroDoFiltro = true;
            } else {
              dentroDoFiltro = false;
            }

            if (dentroDoFiltro) {
              if (vm.formProjetos.filtro) {
                if (
                  planoFinanceiroItem.DESCRICAO.indexOf(
                    vm.formProjetos.filtro
                  ) >= 0
                ) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return true;
              }
            } else {
              return false;
            }
          });
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    centrosDeResponsabilidadeFiltrados() {
      let vm = this;

      if (this.centrosDeResponsabilidade) {
        if (this.centrosDeResponsabilidade.length) {
          return this.centrosDeResponsabilidade.filter(function(
            centroDeResponsabilidadeItem
          ) {
            if (vm.formProjetos.filtro) {
              if (
                centroDeResponsabilidadeItem.DESCRICAO.indexOf(
                  vm.formProjetos.filtro
                ) >= 0
              ) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          });
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    portadoresFiltrados() {
      let vm = this;

      if (this.portadores) {
        if (this.portadores.length) {
          return this.portadores.filter(function(portadorItem) {
            if (vm.fgEmpresa !== "0") {
              if (portadorItem.ID_EMPRESA && portadorItem.ID_EMPRESA !== "0") {
                if (vm.fgEmpresa == portadorItem.ID_EMPRESA) {
                  if (vm.formProjetos.filtro) {
                    if (
                      portadorItem.NOME.indexOf(vm.formProjetos.filtro) >= 0
                    ) {
                      return true;
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                } else {
                  return false;
                }
              } else {
                if (vm.formProjetos.filtro) {
                  if (portadorItem.NOME.indexOf(vm.formProjetos.filtro) >= 0) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  return true;
                }
              }
            } else {
              if (vm.formProjetos.filtro) {
                if (portadorItem.NOME.indexOf(vm.formProjetos.filtro) >= 0) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return true;
              }
            }
          });
        } else {
          return [];
        }
      } else {
        return [];
      }
    }
  }
};
</script>
